import { filterProductPhoto } from "../../client/js/services/hidePhotosExperiment.ts";

export const filterProductPhotoImpl = filterProductPhoto;
